
/** 枚举 -> 账号交互动作 */
export enum UserActionEnum {
    /** 新增 */
    add = 'ADD',
    /** 编辑 */
    edit = 'EDIT',
    /** 删除 */
    delete = 'DELETE',
    /** 页面查看 */
    view = 'VIEW',

    /** 导出 */
    export = 'EXPORT',
    /** 导入 */
    import = 'IMPORT',
    /** 发送 */
    send = 'SEND',
    /** 登录 */
    login = 'LOGIN',
    /** 登出 */
    logout = 'LOGOUT',

    /** 启用 */
    enable = 'ENABLE',
    /** 禁用 */
    disable = 'DISABLE',
}

/** 枚举 -> 账号交互动作分类 */
export enum ActionLogGroupEnum {
    /** 登录 */
    Login = 'Login',
    /** 登出 */
    Logout = 'Logout',
    /** 用户管理 */
    UserManagement = 'UserManagement',
    /** 安全活动 */
    SecurityActivity = 'SecurityActivity',
    /** 工作流 */
    Workflow = 'Workflow',
    /** 邮件 */
    Mail = 'Mail',
    /** 设置 */
    Setting = 'Setting',
    /** 属性 */
    Property = 'Property',
    /** 联系人 */
    Contact = 'Contact',
    /** 活动 */
    Market = 'Market',
    /** 报表 */
    Report = 'Report',
    /** 短信 */
    SMS = 'SMS',
    /** 资源 */
    Resource = 'Resource',
    /** 项目 */
    Project = 'Project',
}

/** 枚举 -> 账号交互动作code */
export enum ActionLogCodeEnum {
    // ----------------------【 Login - 登录 】----------------------
    /** 登录成功 */
    LoginSuccess = 'LoginSuccess',
    /** 登录失败 */
    LoginFailed = 'LoginFailed',
    // ----------------------【 Logout - 登出 】----------------------
    /** 登录成功 */
    LogoutSuccess = 'LogoutSuccess',
    /** 登录失败 */
    LogoutFailed = 'LogoutFailed',
    // ----------------------【 UserManagement - 用户管理 】----------------------
    /** 创建账号 */
    AddUser = 'AddUser',
    /** 删除账号 */
    DelUser = 'DelUser',
    /** 变更账号信息 */
    UpdateUser = 'UpdateUser',
    /** 权限变更 */
    UpdatePermission = 'UpdatePermission',
    /** 变更公司信息 */
    UpdateAccount = 'UpdateAccount',
    /** 新增团队 */
    AddTeam = "AddTeam",
    /** 更新团队 */
    UpdateTeam = "UpdateTeam",
    /** 删除团队 */
    DelTeam = "DelTeam",
    // ----------------------【 SecurityActivity - 安全活动 】----------------------
    /** 密码修改与重置 */
    PasswordUpdateOrReset = 'PasswordUpdateOrReset',
    /** 新增安全设置 */
    AddSecuritySetting = 'AddSecuritySetting',
    /** 修改安全设置 */
    UpdateSecuritySetting = 'UpdateSecuritySetting',
    // ----------------------【 Workflow - 工作流 】----------------------
    /** 流程启动与终止 */
    ProcessControl = 'ProcessControl',
    /** 创建工作流 */
    AddWorkflow = 'AddWorkflow',
    /** 编辑工作流 */
    EditWorkflow = 'EditWorkflow',
    /** 删除工作流 */
    DelWorkflow = 'DelWorkflow',
    // ----------------------【 Mail - 邮件 】----------------------
    /** 创建邮件 */
    AddMail = 'AddMail',
    /** 发送邮件 */
    SendMail = 'SendMail',
    /** 编辑邮件 */
    EditMail = 'EditMail',
    /** 删除邮件 */
    DelMail = 'DelMail',
    /** 导出邮件任务 */
    ExportMailList = 'ExportMailList',
    /** 导出邮件报表 */
    ExportMailReport = 'ExportMailReport',
    /** 新增发件人 */
    AddSender = 'AddSender',
    /** 删除发件人 */
    DelSender = 'DelSender',
    /** 新增链接跟踪域名 */
    AddFromDomain = 'AddFromDomain',
    /** 开启/关闭跟踪打开 */
    TurnTrackOpen = 'TurnTrackOpen',
    /** 开启/关闭跟踪点击 */
    TurnTrackClick = 'TurnTrackClick',
    // ----------------------【 Setting - 设置 】----------------------
    /** 设置变更 */
    SettingChange = 'SettingChange',
    /** 新增设置 */
    AddSetting = 'AddSetting',
    /** 新增订阅信息 */
    AddSubscript = 'AddSubscript',
    /** 更新订阅信息 */
    EditSubscript = 'EditSubscript',
    /** 删除订阅信息 */
    DelSubscript = 'DelSubscript',
    /** 绑定订阅信息 */
    BindSubscript = 'BindSubscript',
    /** 解绑订阅信息 */
    UnBindSubscript = 'UnBindSubscript',
    /** 新增自定义退订链接 */
    AddUnSubscribeUrl = 'AddUnSubscribeUrl',
    /** 更新自定义退订链接 */
    EditUnSubscribeUrl = 'EditUnSubscribeUrl',
    /** 删除自定义退订链接 */
    DelUnSubscribeUrl = 'DelUnSubscribeUrl',
    /** 新增资质信息 */
    AddCert = 'AddCert',
    /** 更新资质信息 */
    EditCert = 'EditCert',
    /** 删除资质信息 */
    DelCert = 'DelCert',
    /** 新增页眉页脚 */
    AddHeaderFooter = 'AddHeaderFooter',
    /** 更新页眉页脚 */
    EditHeaderFooter = 'EditHeaderFooter',
    /** 删除页眉页脚 */
    DelHeaderFooter = 'DelHeaderFooter',
    // ----------------------【 Property - 属性 】----------------------
    /** 新增属性 */
    AddProperty = 'AddProperty',
    /** 属性变更 */
    UpdateProperty = 'UpdateProperty',
    /** 删除属性 */
    DelProperty = 'DelProperty',
    // ----------------------【 Contact - 联系人 】----------------------
    /** 导入联系人 */
    ImportContact = 'ImportContact',
    /** 导出黑名单 */
    ExportBlacklist = 'ExportBlacklist',
    /** 创建联系人 */
    AddContact = 'AddContact',
    /** 修改联系人 */
    UpdateContact = 'UpdateContact',
    /** 删除联系人 */
    DelContact = 'DelContact',
    /** 创建联系组 */
    AddGroup = 'AddGroup',
    /** 修改联系组 */
    UpdateGroup = 'UpdateGroup',
    /** 删除联系组 */
    DelGroup = 'DelGroup',
    /** 审批导入联系人 */
    ReviewImportContact = 'ReviewImportContact',
    // ----------------------【 Market - 活动 】----------------------
    /** 新增活动 */
    AddMarket = 'AddMarket',
    /** 更新活动 */
    EditMarket = 'EditMarket',
    /** 删除活动 */
    DelMarket = 'DelMarket',
    // ----------------------【 Report - 报表 】----------------------
    /** 新增报表 */
    AddReport = 'AddReport',
    /** 更新报表 */
    EditReport = 'EditReport',
    /** 删除报表 */
    DelReport = 'DelReport',
    /** 导出报表 */
    ExportReport = 'ExportReport',
    // ----------------------【 SMS - 短信 】----------------------
    /** 新增短信任务 */
    AddSmsTask = 'AddSmsTask',
    /** 更新短信任务 */
    EditSmsTask = 'EditSmsTask',
    /** 删除短信任务 */
    DelSmsTask = 'DelSmsTask',
    /** 发送短信任务 */
    SendSmsTask = 'SendSmsTask',
    /** 导出短信任务 */
    ExportSmsTask = 'ExportSmsTask',
    /** 导出短信明细 */
    ExportSmsDetail = 'ExportSmsDetail',
    /** 新增短信签名 */
    AddSmsSign = 'AddSmsSign',
    /** 更新短信签名 */
    EditSmsSign = 'EditSmsSign',
    /** 删除短信签名 */
    DelSmsSign = 'DelSmsSign',
    // ----------------------【 Resource - 资源 】----------------------
    /** 新增资源 */
    AddResource = 'AddResource',
    /** 删除资源 */
    DelResource = 'DelResource',
    /** 创建邮件模板 */
    AddMailTemplate = 'AddMailTemplate',
    /** 编辑邮件模板 */
    EditMailTemplate = 'EditMailTemplate',
    /** 删除邮件模板 */
    DelMailTemplate = 'DelMailTemplate',
    /** 新增短信模板 */
    AddSmsTemplate = 'AddSmsTemplate',
    /** 更新短信模板 */
    EditSmsTemplate = 'EditSmsTemplate',
    /** 删除短信模板 */
    DelSmsTemplate = 'DelSmsTemplate',
    /** 新增项目 */
    AddProject = 'AddProject',
    /** 更新项目 */
    EditProject = 'EditProject',
    /** 删除项目 */
    DelProject = 'DelProject',
    /** 启用项目 */
    EnableProject = 'EnableProject',
    /** 禁用项目 */
    DisableProject = 'DisableProject',

}

/** 枚举 -> cookie中缓存的各种key */
export enum Cookie_Keys_Enum {
    /** cookie中缓存的语言选项-key */
    language = 'language',
}




// ------------------------------------- 【常量定义】 -------------------------------------
/** [定义]日期格式 */
export enum DateFormat {
    /** [定义]日期格式：yyyy */
    YYYY = 'YYYY',
    /** [定义]日期格式：yyyy-MM */
    YYYY_MM = 'YYYY-MM',
    /** [定义]日期格式：yyyy-MM-dd */
    YYYY_MM_DD = 'YYYY-MM-DD',
    /** [定义]日期格式：yyyy-MM-dd HH */
    YYYY_MM_DD_HH = 'YYYY-MM-DD HH',
    /** [定义]日期格式：yyyy-MM-dd HH:mm */
    YYYY_MM_DD_HH_mm = 'YYYY-MM-DD HH:mm',
    /** [定义]日期格式：yyyy-MM-dd HH:mm:ss */
    YYYY_MM_DD_HH_mm_ss = 'YYYY-MM-DD HH:mm:ss',
}
/** [定义]权限码 */
export enum AuthCode {
    /** 【特殊权限码】smtpEmailMask：限制SMTP发送的邮箱是否显示完全（展示敏感信息） */
    smtpEmailMask = 'smtpEmailMask',
    /** 【特殊权限码】auditImportContact：限制用户是否可以审核联系人导入任务 */
    auditImportContact = 'auditImportContact',
    /** 【特殊权限码】auditMailList：限制用户是否可以审核其他账户的邮件列表任务(内容审核) */
    auditMailList = 'auditMailList',
    /** 【特殊权限码】auditMailListForBulkContactSend：限制用户是否可以审核其他账户的邮件列表任务(联系人审核) */
    auditMailListForBulkContactSend = 'auditMailListForBulkContactSend',
    /** 【特殊权限码】ignoreAdminAudit：限制用户提交邮件任务时，是否需要管理员审核 */
    ignoreAdminAudit = 'ignoreAdminAudit',
    /** 【特殊权限码】ignoreBulkContactSendAudit：限制用户提交邮件任务时，所选联系人数量超限后，是否需要管理员审核 */
    ignoreBulkContactSendAudit = 'ignoreBulkContactSendAudit',
    /** 【特殊权限码】editTraceSetting：限制【设置】-【邮件配置】-【链接跟踪】页面上的相关数据更新操作。 涉及【跟踪邮件打开 | 点击】，【默认跟踪链接设置】，【跟踪链接域名新增 | 删除】，【SSL证书申请 | 续期】 */
    editTraceSetting = 'editTraceSetting',
    /** 【特殊权限码】viewOtherMembersAnalysis: 能否查看其他账户的邮件列表分析数据 */
    viewOtherMembersAnalysis = 'viewOtherMembersAnalysis',
    /** 【特殊权限码】viewAllGroup: 能否查看所有分组的数据 */
    viewAllGroup = 'viewAllGroup',
    /** 【特殊权限码】UseAllGroup: 能否使用所有分组 */
    useAllGroup = 'UseAllGroup',
    /** 【特殊权限码】showContactOptionsInMailSetting: 是否在邮件发送设置中显示联系人下拉框 */
    showContactOptionsInMailSetting = 'showContactOptionsInMailSetting',
    /** 【特殊权限码】linkMagicCube: 是否在邮件发送设置中显示链接魔方 */
    linkMagicCube = 'linkMagicCube',
    /** 【页面权限码】/channel/checkFromDomain: 能否查看添加发送方域名页面 */
    channel_checkFromDomain = '/channel/checkFromDomain',

    /** 【页面权限码】view:/contact/list: 能否查看联系人列表 */
    view_contact_list = 'view:/contact/list',
    /** 【页面权限码】/contact/addContact: 能否添加联系人 */
    contact_addContact = '/contact/addContact',
    /** 【页面权限码】/contact/importContacts: 能否导入联系人 */
    contact_importContacts = '/contact/importContacts',
    /** 【页面权限码】/marketing/addMarket: 能否添加营销活动 */
    marketing_addMarket = '/marketing/addMarket',
    /** 【页面权限码】/marketing/editMarket: 能否编辑营销活动 */
    marketing_editMarket = '/marketing/editMarket',
    /** 【页面权限码】/project/addProject: 能否添加项目 */
    project_addProject = '/project/addProject',
    /** 【页面权限码】/project/updateProject: 能否编辑项目 */
    project_updateProject = '/project/updateProject',
}

/** [定义]邮件语言映射 */
export const MailLanguageMap: Record<string, string> = {
    "1": "简体中文",
    "8": "繁体中文",
    "2": "英文",
    "3": "日文",
    "4": "韩文",
    "5": "德文",
    "6": "俄文",
    "7": "西班牙文",
    "9": "阿拉伯文",
    "10": "葡萄牙文（巴西）",
    "11": "印尼文",
    "12": "越南文",
    "13": "泰文",
    "14": "法文",
}
export const languageOptions: any[] = [
    { value: '1', label: `简体中文` },
    { value: '8', label: `繁體中文` }, { value: '2', label: `English (英语)` },
    { value: '3', label: `日语` }, { value: '4', label: `Korean (韩语)` },
    { value: '5', label: `German (德语)` }, { value: '6', label: `Русский язык (俄语)` },
    { value: '7', label: `Español (西班牙语)` }, { value: '9', label: `العربية (阿拉伯语)` },
    { value: '10', label: `Português (葡萄牙语)` }, { value: '11', label: `Bahasa Indonesia (印尼语)` },
    { value: '12', label: `Tiếng Việt (越南语)` }, { value: '13', label: `ไทย (泰语)` },
    { value: '14', label: `Français (法语)` },
];

/** [定义]用户配置key */
export const UserConfigKeys = {
    SmtpArchiveDays: 'SmtpArchiveDays',
}

/** [定义]公司配置key */
export const AccountConfigKeys = {
    /** 是否在邮件发送设置中显示联系人下拉框 */
    Mail_showContactOptionsInMailSetting: 'Mail_showContactOptionsInMailSetting',
    /** 下载SMTP邮件内容文件时，能否使用海外节点 */
    Mail_SMTPDownload_UseOverseasNode: 'Mail_SMTPDownload_UseOverseasNode',
    /** 导入联系人：能否展示且默认选中《仅用于本次发送》选项 */
    Import_OnlyThisSend: 'Import_OnlyThisSend',
    /** 导入联系人：能否展示《导入到组》选项 */
    Import_ShowToGroup: 'Import_ShowToGroup',
}



